define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TravelTypeDomain = void 0;
    class TravelTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: TravelTypeDomain.NormalTravel, value: "Normal Travel" },
                    { key: TravelTypeDomain.SlowTravel, value: "Slow Travel" },
                    { key: TravelTypeDomain.UnfitStockTravel, value: "Unfit Stock Travel" },
                    { key: TravelTypeDomain.UnfitStockGrazing, value: "Unfit Stock Grazing" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[TravelTypeDomain.NormalTravel] = 0;
                this.KeyIndex[TravelTypeDomain.SlowTravel] = 1;
                this.KeyIndex[TravelTypeDomain.UnfitStockTravel] = 2;
                this.KeyIndex[TravelTypeDomain.UnfitStockGrazing] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Normal Travel"] = 0;
                this.ValueIndex["Slow Travel"] = 1;
                this.ValueIndex["Unfit Stock Travel"] = 2;
                this.ValueIndex["Unfit Stock Grazing"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.TravelTypeDomain = TravelTypeDomain;
    Object.defineProperty(TravelTypeDomain, "NormalTravel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(TravelTypeDomain, "SlowTravel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(TravelTypeDomain, "UnfitStockTravel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(TravelTypeDomain, "UnfitStockGrazing", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(TravelTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
